import { useMemo } from 'react'

type AdProps = {
  width: number
  height: number
}

const Ad = ({ width, height }: AdProps) => {
  // #region スタイル

  const adStyle: React.CSSProperties = {
    border: 0,
    overflow: 'hidden',
    margin: '0 10px 0 10px'
  }

  // #endregion スタイル

  const size = `${width}x${height}`

  const src = useMemo(() => {
    return `/common/ads/api.php?size=${encodeURIComponent(size)}&t=${Date.now()}`
  }, [size])

  return <iframe src={src} width={width} height={height} style={adStyle} title={`ad-${size}`} />
}

export default Ad
